import React from "react"
import moment from "moment"
import { snakeCase } from "lodash"
import { MenuCategory } from "../MenuCategory"
import { MenuNavigation } from "../MenuNavigation"
import { MenuFilters } from "../MenuFilters"

export interface MenuProps {
  featuredItems?: any,
  weekOf?: Date,
  availableDates?: Date[]
  changeDate?: Function,
  scrollOffset?: Number
}

export interface IMenuCategory {
  name: string,
  anchorName: string,
  sortOrder: Number,
  items: any[]
}

class MenuInner extends React.Component<MenuProps> {
  constructor(props = {}) {
    super(props)

    this.renderCategory = this.renderCategory.bind(this)
  }

  itemCategories(items) {
    const categories = items.reduce((collection, item) => {
      const collectionIndex = collection.findIndex((element) => element.name === item.category.name)
      if (collectionIndex < 0) {
        const newCategory: IMenuCategory = {
          ...item.category,
          anchorName: snakeCase(item.category.name),
          items: [item],
        }
        collection.push(newCategory)
      } else {
        collection[collectionIndex].items.push(item)
      }
      return collection
    }, [])

    return categories
  }

  renderCategory(category: IMenuCategory, index: number) {
    const { scrollOffset } = this.props
    return (
      <MenuCategory
        name={category.name}
        items={category.items}
        anchorName={category.anchorName}
        scrollOffset={scrollOffset}
        key={index}
      />
    )
  }

  render() {
    const {
      weekOf, featuredItems, availableDates, changeDate, scrollOffset,
    } = this.props
    const date = moment.utc(weekOf)
    const categories = this.itemCategories(featuredItems)
    return (
      <section className="mb-14">
        <div className="md:flex">
          <nav title="Upcoming menu navigation." className="sm:w-full md:w-2/12 sm:pr-7 self-stretch">
            <MenuFilters options={categories} scrollOffset={scrollOffset} />
          </nav>

          <div className="sm:w-full md:w-10/12">
            <div className="flex justify-between mb-4">
              <MenuNavigation
                availableDates={availableDates!}
                currentDate={date.toDate()}
                onChange={changeDate}
              />
            </div>

            {categories.map(this.renderCategory)}
          </div>
        </div>
      </section>
    )
  }
}

export function Menu(props: MenuProps) {
  return <MenuInner {...props} />
}
